import { motion } from "framer-motion";

export default function FadeUp({ children, delay = 0.3, className = "" }) {
  return (
    <motion.div
        className={className}
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut", delay }}
        viewport={{ once: true }}
    >
        {children}
    </motion.div>
  );
}